import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { produce } from 'immer';

import { EmployeeInfo } from 'src/app/api/models/employees/employees.intrface';

export interface SystemEmployeesState extends EntityState<EmployeeInfo, string> { }

// 1. the store saves employees of specific system
// 2. once the employees panel is closed, the store will be reset to empty.
// 3. the store will be filled with employees again in the next time the user will open the panel
// 4. I used this store strategy to get akita pagination
@Injectable({
	providedIn: 'root',
})
@StoreConfig({
	name: 'systemEmployees',
	idKey: 'id',
	producerFn: produce
})
export class SystemEmployeesStore extends EntityStore<SystemEmployeesState> {
	constructor() {
		super();
	}
}